module.exports = __webpack_public_path__ + "static/wildwood-logo-1818f738044169de1da8ee1b22620a76.png";